export function initExpand(buttonSelector, foldSelector) {
  const deactivateOthers = (button, fold) => {
    const activeButton = document.querySelector(`${buttonSelector}.active`)
    const activeFolds = document.querySelectorAll(`${foldSelector}.expanded`)

    if (activeButton && activeButton !== button)
      activeButton.classList.remove("active")

    for (const activeFold of activeFolds) {
      if (activeFold && activeFold !== fold) {
        activeFold.classList.remove("expanded")
        activeFold.classList.add("hidden")
      }
    }
  }

  function setInitialFold() {
    const hash = window.location.hash

    if (hash.includes("tag_")) {
      const button = document.querySelector(hash)
      const controls = button.getAttribute("aria-controls")
      const folds = document.querySelectorAll(`[id^=${controls}]`)

      if (button) {
        for (const fold of folds) {
          deactivateOthers(button, fold)
          button.classList.add("active")
          setTimeout(() => fold.classList.add("expanded"), 200)
          // Unhide before announcing, as the click handler below does: the
          // accordions listening for _opened_fold measure their heights, and
          // ``.hidden`` is ``display: none``, so they would all measure zero.
          fold.classList.remove("hidden")
          fold.dispatchEvent(new Event("_opened_fold", { bubbles: true }))
        }
        button.scrollIntoView({ behavior: "smooth" })
      }
    }
  }
  setInitialFold()

  document.body.addEventListener("click", (e) => {
    const button = e.target?.closest(buttonSelector)

    if (button) {
      const controls = button.getAttribute("aria-controls")
      const folds = document.querySelectorAll(`[id^=${controls}]`)

      if (button.classList.contains("active")) {
        for (const fold of folds) {
          deactivateFold(fold)
        }
        button.classList.remove("active")
      } else {
        for (const fold of folds) {
          deactivateOthers(button, fold)

          button.classList.add("active")
          setTimeout(() => fold.classList.add("expanded"), 200)
          fold.classList.remove("hidden")
          window.location.hash = `#${button.id}`
          fold.dispatchEvent(new Event("_opened_fold", { bubbles: true }))
          fold.addEventListener("_close_fold", (_e) => {
            deactivateFold(fold)
          })
        }
      }
    }
  })

  const deactivateFold = (target) => {
    const activeButtonId = target.getAttribute("aria-controlled-by")
    const activeButton = document.getElementById(activeButtonId)
    if (activeButton) activeButton.classList.remove("active")
    target.classList.remove("expanded")
    target.classList.add("hidden")
  }

  document.body.addEventListener("click", (e) => {
    const button = e.target?.closest(".button.-close")
    if (button) {
      const parent = button.parentElement
      if (parent.classList.contains("expanded")) {
        deactivateFold(parent)
      }
    }
  })

  document.body.addEventListener("keydown", (e) => {
    if (e.code === "Escape") {
      const target = document.querySelector(".expanded:has(.button.-close)")
      if (target) deactivateFold(target)
    }
  })

  window.addEventListener("_close_fold", (e) => {
    deactivateFold(e.target)
  })
}

export function initCloseOnScroll(foldSelector) {
  const folds = document.querySelectorAll(foldSelector)
  for (const fold of folds) {
    fold.addEventListener("_opened_fold", (_e) => {
      window.addEventListener(
        "scroll",
        (_e) => {
          fold.dispatchEvent(new Event("_close_fold"))
        },
        { once: true },
      )
    })
  }
}
